import React, { useMemo } from 'react';
import classNames from 'classnames';
import Avatar from '../../../Avatar/CaregiverAvatar';
import Utils from '../../../../utils/utils';
import AVAILABILITY_BADGES from '../../../../constants/AvailabilityBadges';

import './ProfessionalRow.scss';

const ProfessionalRow = ({ professional }) => {
	const shiftsWorked = professional.shifts_worked
		? `${Utils.pluralize(`${professional.shifts_worked} shift`, 's', parseInt(professional.shifts_worked, 10))} worked`
		: '';
	const distance = professional.distance ? `${Math.round(professional.distance)} mi` : null;

	const badgeStyle = AVAILABILITY_BADGES[professional.status].style;

	const shouldDisable = useMemo(() => professional.status === AVAILABILITY_BADGES.ASSIGNED.status, [professional]);

	return (
		<div className={classNames("professional-row__container", {disabled: shouldDisable})}>
			<Avatar caregiverId={professional.caregiver_id} />
			<div className={classNames("professional-row__info", {disabled: shouldDisable})}>
				<span className="professional-row__info__name">
					{professional.caregiver_name}
					{professional.certification_type ? `, ${professional.certification_type}` : ''}
				</span>
				<span className="professional-row__info__data">
					{shiftsWorked}
					{distance ? `; ${Utils.formatNumber(distance)}` : ''}
				</span>
			</div>

			<div className="professional-row__badge">
				<div className={`professional-row__badge__pill professional-row__badge__pill--${badgeStyle}`}>
					{AVAILABILITY_BADGES[professional.status].name}
				</div>
			</div>
		</div>
	);
};
export default ProfessionalRow;
